import React, { useState, useRef, LegacyRef, CSSProperties, useEffect } from "react";
import { 
    View,
    StyleSheet
} from "react-native";
import { ReactComponent as RowSelectCheckBoxInactiveImg } from "../../../img/btn-checkbox-incon-circle-inactive.svg";
import { ReactComponent as RowSelectCheckBoxActiveImg } from "../../../img/btn-checkbox-incon-circle-active.svg";


interface RowSelectCheckBoxProps {
    size: number;
    onChange: Function;
    checked: boolean;
} 

function RowSelectCheckBox(props:RowSelectCheckBoxProps) {
    const [checkBoxImgStyle, setCheckBoxImgStyle] = useState(className.checkBoxImg);

    useEffect(() => {
        setCheckBoxImgStyle({...checkBoxImgStyle, width: props.size + "px", height: props.size + "px"});
    }, []);
    

    function onselectionchange(event:React.ChangeEvent) {
        props.onChange(event);
        event.stopPropagation();
        
    }
    return (
        <label>
            <input 
                type={"checkbox"}
                // {...props}
                checked={props.checked}
                onChange={(e) => {onselectionchange(e);}}
                // indeterminate={props.indeterminate ? true : false}
                style={className.checkBox}
            />
            <View style={style.checkBoxImgContainer}>
                {
                    props.checked ?
                    <RowSelectCheckBoxActiveImg style={checkBoxImgStyle} /> : <RowSelectCheckBoxInactiveImg style={checkBoxImgStyle} />
                }
            </View>
        </label>
        
    );
}


const style = StyleSheet.create({
    checkBoxImgContainer: {
        flexDirection: "row",
        alignItems: "center",
    },

});

const className = {
    checkBox: {
        border: "0px",
        width: "0px",
        height: "0px",
        display: "none"
    },
    checkBoxImg: {
        width: "18px",
        height: "18px",
        margin: "0 10px",
        cursor: "pointer"
    }
};

export default RowSelectCheckBox;